'use client'
import React from 'react'
import CompanyPage from '../CompanyPage'
const layout = ({
  children,
  params,
}: {
  children: React.ReactNode
  params: {
    id: string
  }
}) => {
  return (
    <>
      <CompanyPage tab={children} id={params.id} />
    </>
  )
}

export default layout
